import { ApiError } from './client';
import { useAuthStore } from '@/hooks/useStore';

export interface AuthenticationOwner {
  token: string;
  userId: string;
}

export function requireAuthenticationOwner(): AuthenticationOwner {
  const { token, user } = useAuthStore.getState();
  if (!token || !user) throw new ApiError('Authentication is required to download this file', 401);
  return { token, userId: user.id };
}

export function assertAuthenticationOwner(owner: AuthenticationOwner): void {
  const current = useAuthStore.getState();
  if (!current.token || current.user?.id !== owner.userId) {
    throw new ApiError('Download cancelled because the signed-in account changed', 409);
  }
}

export async function binaryResponseError(
  response: Response,
  fallbackMessage: string,
): Promise<ApiError> {
  const payload: unknown = await response.json().catch(() => null);
  const data =
    payload && typeof payload === 'object' && !Array.isArray(payload)
      ? (payload as Record<string, unknown>)
      : null;
  const message = typeof data?.error === 'string' ? data.error : fallbackMessage;
  return new ApiError(message, response.status, data);
}
